import './App.css';

import { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import AuthPage from '../pages/Auth';
import ChatPage from '../pages/Chat';
import CodeAgentPage from '../pages/CodeAgent/CodeAgentPage';
import CodeAgentTaskPage from '../pages/CodeAgent/CodeAgentTaskPage';
import ConnectEmailPage from '../pages/ConnectEmail';
import ConnectGithubPage from '../pages/ConnectGithub';
import ConnectJiraPage from '../pages/ConnectJira';
import ConnectMcpPage from '../pages/ConnectMcp';
import ConnectSlackPage from '../pages/ConnectSlack';
import ConnectTrelloPage from '../pages/ConnectTrello';
import DashboardLayout from '../pages/Dashboard.layout';
import AiChat from '../pages/Docs/AiChat';
import AiProvidersDocs from '../pages/Docs/AiProviders';
import ChatDocs from '../pages/Docs/Chat';
import CodingAgentDocs from '../pages/Docs/CodingAgent';
import ConnectEmailDocs from '../pages/Docs/ConnectEmail';
import ConnectJiraDocs from '../pages/Docs/ConnectJira';
import ConnectSlackDocs from '../pages/Docs/ConnectSlack';
import ConnectTelegramDocs from '../pages/Docs/ConnectTelegram';
import ConnectTrelloDocs from '../pages/Docs/ConnectTrello';
import DashboardOverviewDocs from '../pages/Docs/DashboardOverview';
import DocsLayout from '../pages/Docs/DocsLayout';
import Faq from '../pages/Docs/Faq';
import GitReviewerDocs from '../pages/Docs/GitReviewer';
import KnowledgeBaseDocs from '../pages/Docs/KnowledgeBase';
import McpServerDocs from '../pages/Docs/McpServer';
import Platforms from '../pages/Docs/Platforms';
import PsiScore from '../pages/Docs/PsiScore';
import SettingsDocs from '../pages/Docs/Settings';
import SignInDocs from '../pages/Docs/SignIn';
import StandaloneModeDocs from '../pages/Docs/StandaloneMode';
import ToolReference from '../pages/Docs/ToolReference';
import TransferDocs from '../pages/Docs/Transfer';
import WhatIsMflow from '../pages/Docs/WhatIsMflow';
import WizardDocs from '../pages/Docs/Wizard';
import GitReviewerPage from '../pages/GitReviewer/GitReviewerPage';
import IntegrationPage from '../pages/Integration';
import KnowledgeDocPage from '../pages/Knowledge/KnowledgeDocPage';
import KnowledgeListPage from '../pages/Knowledge/KnowledgeListPage';
import LogoutPage from '../pages/Logout';
import NotFound from '../pages/NotFound';
import SessionChatPage from '../pages/SessionChatPage';
import SettingsPage from '../pages/Settings';
import StandaloneBoardPage from '../pages/Standalone/StandaloneBoardPage';
import StandaloneProjectsPage from '../pages/Standalone/StandaloneProjectsPage';
import StandaloneTaskDetailPage from '../pages/Standalone/StandaloneTaskDetailPage';
import JiraTaskDetailPage from '../pages/Stats/JiraTaskDetailPage';
import { ProjectDetailPage } from '../pages/Stats/ProjectDetailPage';
import { ProjectsStatsPage } from '../pages/Stats/ProjectsStatsPage';
import { StudioChartPage } from '../pages/Stats/StudioChartPage';
import TrelloTaskDetailPage from '../pages/Stats/TrelloTaskDetailPage';
import { UsersStatsPage } from '../pages/Stats/UsersStatsPage';
import { UserStatsPage } from '../pages/Stats/UserStatsPage';
import TransferJobPage from '../pages/Transfer/TransferJobPage';
import TransferJobsListPage from '../pages/Transfer/TransferJobsListPage';
import Layout from '../widgets/Layout';
import AuthGuard from './guards/AuthGuard';

function App() {
  useEffect(() => {
    const addTargetBlankToExternalLinks = () => {
      const links = document.querySelectorAll('a');
      links.forEach((link) => {
        const href = link.getAttribute('href');

        // Проверяем, что это внешняя ссылка
        if (
          href &&
          (href.startsWith('http://') || href.startsWith('https://')) &&
          !href.includes(window.location.host)
        ) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      });
    };

    // Используем MutationObserver для динамических изменений
    const observer = new MutationObserver(addTargetBlankToExternalLinks);
    observer.observe(document.body, { childList: true, subtree: true });

    // Вызываем функцию для ссылок, которые уже есть на странице
    addTargetBlankToExternalLinks();

    // Очистка
    return () => {
      observer.disconnect();
    };
  }, []);
  return (
    <div>
      <Router>
        <Routes>
          <Route element={<AuthGuard />}>
            <Route element={<Layout />}>
              <Route element={<DashboardLayout />}>
                <Route path="/" element={<StudioChartPage />} />
                <Route path="/dashboard" element={<StudioChartPage />} />
                <Route path="/dashboard/projects" element={<ProjectsStatsPage />} />
                <Route path="/dashboard/projects/:projectId" element={<ProjectDetailPage />} />
                <Route path="/dashboard/projects/:projectId/users" element={<UsersStatsPage />} />
                <Route path="/dashboard/projects/:projectId/users/:accountId" element={<UserStatsPage />} />
                <Route path="/dashboard/projects/:projectId/tasks/:issueId" element={<JiraTaskDetailPage />} />
                <Route path="/dashboard/projects/:projectId/cards/:cardId" element={<TrelloTaskDetailPage />} />
              </Route>
              <Route path="/standalone" element={<StandaloneProjectsPage />} />
              <Route path="/standalone/tasks/:key" element={<StandaloneTaskDetailPage />} />
              <Route path="/standalone/:projectId" element={<StandaloneBoardPage />} />
              <Route path="/dashboard/projects/:projectId/knowledge" element={<KnowledgeListPage />} />
              <Route path="/dashboard/projects/:projectId/knowledge/:docId" element={<KnowledgeDocPage />} />
              <Route path="/coding-agent" element={<CodeAgentPage />} />
              <Route path="/git-reviewer" element={<GitReviewerPage />} />
              <Route path="/coding-agent/tasks/:taskId" element={<CodeAgentTaskPage />} />
              <Route path="/transfer" element={<TransferJobsListPage />} />
              <Route path="/transfer/:jobId" element={<TransferJobPage />} />
              <Route path="/chat" element={<ChatPage />} />
              <Route path="/chat/sessions/:sessionId" element={<SessionChatPage />} />
              <Route path="/chat/:chatId" element={<ChatPage />} />
              {/* <Route path="/chat/:taskManager/:projectId" element={<ChatPage/>}/> */}
              {/* <Route path="/chat/:taskManager/:projectId/:chatId" element={<ChatPage/>}/> */}
              {/*<Route path="/projects" element={<ProjectsPage />} />*/}
              <Route path="/integrations" element={<IntegrationPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/logout" element={<LogoutPage />} />
            </Route>
          </Route>
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/connect-mcp" element={<ConnectMcpPage />} />
          <Route path="/docs" element={<DocsLayout />}>
            <Route index element={<WhatIsMflow />} />
            <Route path="sign-in" element={<SignInDocs />} />
            <Route path="dashboard" element={<DashboardOverviewDocs />} />
            <Route path="psi" element={<PsiScore />} />
            <Route path="platforms" element={<Platforms />} />
            <Route path="standalone" element={<StandaloneModeDocs />} />
            <Route path="connect-jira" element={<ConnectJiraDocs />} />
            <Route path="connect-trello" element={<ConnectTrelloDocs />} />
            <Route path="connect-slack" element={<ConnectSlackDocs />} />
            <Route path="connect-telegram" element={<ConnectTelegramDocs />} />
            <Route path="connect-email" element={<ConnectEmailDocs />} />
            <Route path="settings" element={<SettingsDocs />} />
            <Route path="ai-providers" element={<AiProvidersDocs />} />
            <Route path="wizard" element={<WizardDocs />} />
            <Route path="transfer" element={<TransferDocs />} />
            <Route path="coding-agent" element={<CodingAgentDocs />} />
            <Route path="git-reviewer" element={<GitReviewerDocs />} />
            <Route path="knowledge-base" element={<KnowledgeBaseDocs />} />
            <Route path="ai-chat" element={<AiChat />} />
            <Route path="chat" element={<ChatDocs />} />
            <Route path="mcp" element={<McpServerDocs />} />
            <Route path="ai-chat/tools" element={<ToolReference />} />
            <Route path="faq" element={<Faq />} />
          </Route>
          <Route path="/connect/jira" element={<ConnectJiraPage />} />
          <Route path="/connect/slack" element={<ConnectSlackPage />} />
          <Route path="/connect/trello/callback" element={<ConnectTrelloPage />} />
          <Route path="/connect/email" element={<ConnectEmailPage />} />
          <Route path="/connect/github" element={<ConnectGithubPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
